module.exports = __webpack_public_path__ + "static/img/1.c9006ea.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/7/zh/1.png
// module id = F338
// module chunks = 0